import React, { useRef, useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import mapboxgl from '!mapbox-gl';

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_KEY
const mapstyle = "mapbox://styles/mapbox/streets-v11"

export default function MapboxGLMap(props) {
  const { requestBbox, markers, mapsize, clickStation } = props;
  const mapContainer = useRef(null);

  // Defind Marker and interactions
  const Marker = ({ feature }) => {
    const [ stnInfo, setStnInfo ] = useState("")
    return (
      <button 
        onClick={() => clickStation(feature)}
        onMouseEnter={() => setStnInfo(feature)}
        onMouseLeave={() => setStnInfo("")}
        style={{
          backgroundColor: "blue",
          color: "white",
          border: "0",
          padding: "7px",
          fontSize: "12px",
        }}
      >
        {stnInfo.name_and_vdr}
      </button>
    );
  };

  const getMapCoords = () => {
    const bbox = requestBbox
    const centerlon = (bbox[0] + bbox[2])/2.0
    const centerlat = (bbox[1] + bbox[3])/2.0
    const center = [centerlon, centerlat]
    const bounds = [
      [bbox[0], bbox[1]], 
      [bbox[2], bbox[3]]
    ]
    return {bounds, center}
  }

  useEffect(() => {
    const { bounds, center } = getMapCoords();
    const map = new mapboxgl.Map({
      container: mapContainer.current,
      style: mapstyle,
      center: center,
    });

    // Select Zoom level to fit bounding box
    map.fitBounds(bounds);

    // Render custom marker components
    markers.forEach((feature) => {
      // Create a React ref
      const ref = React.createRef();
      // Create a new DOM node and save it to the React ref
      ref.current = document.createElement('div');
      // Render a Marker Component on our new DOM node
      createRoot(ref.current).render(
        <Marker feature={feature}/>
      );
      // Create a Mapbox Marker at our new DOM node
      new mapboxgl.Marker(ref.current)
        .setLngLat(feature.position)
        .addTo(map);
    });

    // Add navigation control 
    map.addControl(new mapboxgl.NavigationControl({showCompass:false}), "top-left");

    // Clean up on unmount
    return () => map.remove();
  }, []);

  return (
    <div style={{height:mapsize}} ref={mapContainer} />
  )
}